// extracted by mini-css-extract-plugin
export default {"container":"boletoInfoCard_container__oVk+h","text":"boletoInfoCard_text__8AuDz"};